/**
 * @description modal can draggable ,default:cannot control bottom
 * @param {boolean} draggable
 */
export default {
  data() {
    return {
      dragModal: {
        mouseStartPoint: { left: 0, top: 0 }, // 鼠标开始点击的坐标
        mouseEndPoint: { left: 0, top: 0 }, // 拖动结束的坐标
        mouseDragDown: false,
        basePoint: { left: 0, top: 0 }, // 弹窗的坐标
        moveTarget: null,
        topLeng: 0
      }
    }
  },
  methods: {
    unRegister() {
      $('.modal-dialog').css({ top: '0px', left: '0px' })
      $('body').removeClass('select')
      document.body.onselectstart = document.body.ondrag = null
    },
    registerDraggable() {
      if (this.draggable) {
        let that = this
        $(document).on('mousedown', '.draggable', function(e) {
          // webkit内核和火狐禁止文字被选中
          $('body').addClass('select')
          // ie浏览器禁止文字选中
          document.body.onselectstart = document.body.ondrag = function() {
            return false
          }
          if ($(e.target).hasClass('close')) {
            // 点关闭按钮不能移动对话框
            return
          }
          that.dragModal.mouseDragDown = true
          that.dragModal.moveTarget = $(this)
            .parent()
            .parent()
          that.dragModal.mouseStartPoint = { left: e.clientX, top: e.pageY }
          that.dragModal.basePoint = that.dragModal.moveTarget.offset()
          that.dragModal.topLeng = e.pageY - e.clientY
        })
        $(document).on('mouseup', function(e) {
          if (that.dragModal.moveTarget == undefined) return
          that.dragModal.mouseDragDown = false
          that.dragModal.moveTarget = undefined
          that.dragModal.mouseStartPoint = { left: 0, top: 0 }
          that.dragModal.basePoint = { left: 0, top: 0 }
        })
        $(document).on('mousemove', function(e) {
          if (!that.dragModal.mouseDragDown || that.dragModal.moveTarget == undefined) return
          let mousX = e.clientX
          let mousY = e.pageY
          if (mousX < 0) mousX = 0
          if (mousY < 0) mousY = 25
          that.dragModal.mouseEndPoint = { left: mousX, top: mousY }
          let width = that.dragModal.moveTarget.width()
          let height = that.dragModal.moveTarget.height()
          let clientWidth = document.body.clientWidth
          let clientHeight = document.body.clientHeight
          if (
            that.dragModal.mouseEndPoint.left <
            that.dragModal.mouseStartPoint.left - that.dragModal.basePoint.left
          ) {
            that.dragModal.mouseEndPoint.left = 0
          } else if (
            that.dragModal.mouseEndPoint.left >=
            clientWidth -
              width +
              that.dragModal.mouseStartPoint.left -
              that.dragModal.basePoint.left
          ) {
            that.dragModal.mouseEndPoint.left = clientWidth - width - 38
          } else {
            that.dragModal.mouseEndPoint.left =
              that.dragModal.mouseEndPoint.left -
              (that.dragModal.mouseStartPoint.left - that.dragModal.basePoint.left) // 移动修正，更平滑
          }
          if (
            that.dragModal.mouseEndPoint.top -
              (that.dragModal.mouseStartPoint.top - that.dragModal.basePoint.top) <
            that.dragModal.topLeng
          ) {
            that.dragModal.mouseEndPoint.top = that.dragModal.topLeng
            // 不能超出窗口上边界
          } else if (
            that.dragModal.mouseEndPoint.top - that.dragModal.topLeng >
            clientHeight -
              height +
              that.dragModal.mouseStartPoint.top -
              that.dragModal.basePoint.top
          ) {
            // 因为有阴影遮罩层 ,clientHeight为0，此处失效
            // that.dragModal.mouseEndPoint.top = clientHeight - height - 38 + that.dragModal.topLeng
          } else {
            that.dragModal.mouseEndPoint.top =
              that.dragModal.mouseEndPoint.top -
              (that.dragModal.mouseStartPoint.top - that.dragModal.basePoint.top)
          }

          if (that.dragModal.mouseEndPoint.top + 331 > clientHeight) {
          }
          that.dragModal.moveTarget.offset(that.dragModal.mouseEndPoint)
        })
      }
    }
  }
}
